export default __webpack_public_path__ + "static/william@2x-829a98cd812a02c44ff88c6aee40dbdc.jpg";